module.exports = __webpack_public_path__ + "img/no-data-8v.785bbbf9.png";